import {getData} from './redux_data';
import {
    GET_ZONAS_CENTRO, MODIFY_ZONA_CENTRO, ADD_ZONA_CENTRO, REMOVE_ZONA_CENTRO,
} from '../constants/action_types';

export function getZonasCentro(centroId) {
    return getData('VZonasPpto?centro_id=' + centroId, GET_ZONAS_CENTRO, centroId);
}

export function modifyZonaCentro(zona) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_ZONA_CENTRO, payload: zona });
    }
}

export function addZonaCentro(zona) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_ZONA_CENTRO, payload: zona });
    }
}

export function removeZonaCentro(zona) {
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_ZONA_CENTRO, payload: zona });
    }
}